import React, { useState, useEffect, useCallback, ReactElement } from 'react';
import interest from './Interest/interest.json';
import _ from 'lodash';
import EditableInterestedIn from '../../../atoms/EditableInterestedIn';
import { areEqual } from '../../../utils/helpers';
import PanelTagsWithHeader from '../../../atoms/panels/PanelTagsWithHeader';
import { useDispatch } from 'react-redux';
import { updateProfileInterest } from '../../../actions/profileActions';
import { FONT_FAMILIES } from 'theme/material/constants';
import { getTextColor } from 'style';

interface MoreInfoProps {
  profile: {
    dating_just_dating: string;
    dating_friendship: string;
    dating_marriage: string;
    dating_married: string;
    dating_adult: string;
    dating_mentorship: string;
  };
  editable?: boolean;
  themeDarkMode?: boolean;
}

interface InterestData {
  id: string;
  value: string;
  is_selected: boolean;
}

const interestData = (profile: MoreInfoProps): InterestData[] => {
  const interestsData: any[] = [];

  if (profile) {
    interest.data.map(item => {
      interestsData.push({
        id: item.id,
        value: item.value,
        is_selected: profile['dating_' + item.id] || profile['dating_just_' + item.id] ? true : item.is_selected,
      });
    });
  }

  return interestsData;
};

const MoreInfo = ({ profile, editable }: MoreInfoProps): ReactElement => {
  const dispatch = useDispatch();
  const [interests, setInterests] = useState<boolean>(false);
  const [dating, setDating] = useState<boolean>(false);
  const [friendship, setFriendship] = useState<boolean>(false);
  const [marriage, setMarriage] = useState<boolean>(false);
  const [married, setMarried] = useState<boolean>(false);
  const [adult, setAdult] = useState<boolean>(false);
  const [mentorship, setMentorship] = useState<boolean>(false);

  useEffect(() => {
    mapAllStates();
    return () => {
      setInterests(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  const mapAllStates = useCallback(() => {
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    setDating(findInterest('dating', 'is_selected'));

    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    setFriendship(findInterest('friendship', 'is_selected'));

    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    setMarriage(findInterest('marriage', 'is_selected'));

    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    setMarried(findInterest('married', 'is_selected'));

    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    setAdult(findInterest('adult', 'is_selected'));

    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    setMentorship(findInterest('mentorship', 'is_selected'));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  const findInterest = (id: string, option: string): string => {
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    const allInterests = interestData(profile);
    const myInterest = allInterests.find(type => type.id === id);

    return myInterest[option];
  };

  const makeCall = (id: string, val: string) => {
    eval(`set${_.startCase(id)}(${val})`);
  };

  const toggleEditable = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setInterests(!interests);
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
    // we will track each checkbox onChange and update the state accordingly
    const id = e.currentTarget.id;

    makeCall(id, value);
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    dispatch(
      updateProfileInterest({
        dating_just_dating: dating,
        dating_friendship: friendship,
        dating_marriage: marriage,
        dating_married: married,
        dating_adult: adult,
        dating_mentorship: mentorship,
      })
    );
    toggleEditable(e);
  };

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    toggleEditable(e);
    mapAllStates();
  };

  const moreInfo = {
    dating: dating,
    friendship: friendship,
    marriage: marriage,
    married: married,
    adult: adult,
    mentorship: mentorship,
  };

  const renderData = (): string[] => {
    const data = [];

    Object.getOwnPropertyNames(moreInfo).map(name => {
      moreInfo[name] && data.push(findInterest(name, 'value'));
    });
    return data;
  };

  return (
    <div>
      {interests ? (
        <EditableInterestedIn
          className="profile__interested-in"
          title="What I’m Looking For"
          allInterests={moreInfo}
          onChangeHandler={onChangeHandler}
          findInterest={findInterest}
          handleSubmit={handleSubmit}
          handleCancel={handleCancel}
          customTitleStyle={{
            fontWeight: 400,
            fontFamily: FONT_FAMILIES.secondary,
            lineHeight: '20px',
            letterSpacing: -0.2,
            ...getTextColor().DARK_4,
          }}
        />
      ) : (
        <PanelTagsWithHeader
          className="profile__interested-in"
          title="What I’m Looking For"
          data={renderData()}
          toggleEditable={toggleEditable}
          data-test-id="edit-interested-in"
          panelStyle="borderless"
          editable={editable}
          customTitleStyle={{
            fontWeight: 400,
            fontFamily: FONT_FAMILIES.secondary,
            lineHeight: '20px',
            letterSpacing: -0.2,
            ...getTextColor().DARK_4,
          }}
        />
      )}
    </div>
  );
};

export default React.memo(MoreInfo, areEqual);
